import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import './styles.css'

Vue.use(VueRouter)

const Home = () => import('./views/Home.vue')
const Business = () => import('./views/Business.vue')
const Technology = () => import('./views/Technology.vue')
const Cases = () => import('./views/Cases.vue')
const Contact = () => import('./views/Contact.vue')

const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/', component: Home },
    { path: '/business', component: Business },
    { path: '/technology', component: Technology },
    { path: '/cases', component: Cases },
    { path: '/contact', component: Contact }
  ],
  scrollBehavior: () => ({ x: 0, y: 0 })
})

new Vue({ router, render: h => h(App) }).$mount('#app')